












































import { Component, Prop, Vue } from 'vue-property-decorator'
import { AuthService as _authService } from '@/services/auth.service'
import { UserInfoDto } from '@/models/dtos/userInfoDto'
import router from '@/router'
import { EUserRole } from '@/models/dtos/enums/eUerRole'

@Component
export default class Navigation extends Vue {
  private currentUser: UserInfoDto | null = null

  // Methods
  private logout(): void {
    _authService.logout()
    router.push('/login')
  }

  // Getters
  private get userName() {
    if (this.currentUser?.firstName && this.currentUser?.lastName) {
      return `${this.currentUser.firstName} ${this.currentUser.lastName}`
    }

    return this.currentUser?.userName ?? ''
  }

  private get isAdmin() {
    return this.currentUser && this.currentUser.roles.includes(EUserRole.Admin)
  }

  // Lifecycle
  created() {
    _authService.currentUser().subscribe(userInfo => {
      this.currentUser = userInfo
    })
  }
}
